// extracted by mini-css-extract-plugin
export default {"mainHeader":"BlogHome_mainHeader__qQpGu"};